const ISDEV = process.env.NODE_ENV === 'development' ? true : false
const port = `301`

module.exports = {
    ISDEV: ISDEV,
    devport: parseInt(`18${port}`),
    systemArea: 'jx',
    systemType: 'zzd',
    systemTitle: '危化品企业安全风险智能化管控平台',
    qyTitle: '湖北鑫西康化工有限公司',
    qylogo:'/assets/image/rslogo.png',
    qyweixin:'/assets/image/weixin.jpg',
    systemInfo:'危化品企业安全风险智能化管控平台、人员定位、安全生产、智能巡检、安全管理、基础信息',
    API: `https://zhyqio.mr2.7jj.org.cn/qbe/`,
    ksurl: `https://shio.at.7jj.org.cn/`,
    TOKEN: {
        source: ISDEV?'qbe_dev':'qbe',
        version: 'v1.0',
    },
    UPLOAD: `https://zhyqio.mr2.7jj.org.cn/qbe/upload`,
    UPLOADxxk: `https://shio.at.7jj.org.cn/qbe/uploadxxk`
}
